import axios from "axios"

export default axios.create(
    {
        baseURL:"https://pics-world-api.onrender.com"
    }
)